// extracted by mini-css-extract-plugin
export default {"svg":"LegacyDrawButton_svg__CSpya"};